<template>
  <div class="folder-selector" :style="{height: selectorHeight + 'px'}">
    <div class="selector-box" >
      <div class="top-line">
<!--         <a href="javascript:void(0)" class="back-btn" @click="cancelFolderSelector">返回</a>
 -->        <span class="selector-title">{{$t('operation.moveToFolder')}}</span>
        <i class="icon-add" @click="showInputPop"></i>
        <button class="btn-black" @click="moveToFolder">{{$t('operation.confirm')}}</button>
      </div>
      <div class="folder-list">
        <!-- 文件夹 -->
        <div class="folder-item" :class="{'selected': folder.selected, 'show-default-folder-img': folder.small === null}" v-for="(folder, folderIndex) in folders" :key="folder.id">
          <div class="wrapper" @click="folderCheckboxClick(folderIndex)">
            <div class="layer layer-under"></div>
            <div class="layer layer-middle"></div>
            <div class="layer layer-upper"></div>
            <div class="img-wrap">
              <img class="defaul-folder-img" src="../../assets/images/default_folder.png" alt="">
              <img class="folder-img" v-lazy="folder.small" :style="{width: folder.showWidth + 'px', height: folder.showHeight + 'px'}" alt="">
            </div>
            <div class="folder-msg">
              <i class="icon-folder"></i>
              <span class="folder-title">{{folder.name}}</span>
            </div>
            <div class="checkbox"></div>
          </div>
        </div>
      </div>
    </div>
    <input-pop v-if="inputPop" v-on:closeInputPop="closeInputPop" v-on:newFolder="getFolders"></input-pop>
  </div>
</template>
<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
import Folder from 'common/model/Folder'
import InputPop from './InputPop'
export default {
  name: 'folderSelector',
  props: [''],
  components: {
    InputPop
  },
  created: function () {
    var size = Config.documentSize()
    this.selectorHeight = size.height - 50
    var obj = this
    this.$Lazyload.$on('loaded', function (listener) {
      for (var k = 0; k < obj.folders.length; k++) {
        var folder = obj.folders[k]
        if (folder.isSameSmall(listener.src)) {
          folder.computeShowSize(listener.naturalWidth, listener.naturalHeight)
          return
        }
      }
    })
    this.getFolders()
  },
  data () {
    return {
      selectorHeight: 0,
      folders: [],
      inputPop: false
    }
  },
  methods: {
    scroll: function (event) {
      event = event || window.event
      if (event.preventDefault) {
        // Firefox
        event.preventDefault()
        event.stopPropagation()
      } else {
        // IE
        event.cancelBubble = true
        event.returnValue = false
      }
    },
    getFolders: function () {
      HttpClient.postData(Config.APP_HOST + '/v1/file/dir', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID)
      }, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.folders = []
          for (var i = 0; i < response.body.length; i++) {
            var folder = new Folder()
            folder.loadData(response.body[i])
            this.folders.push(folder)
          }
        }
      })
    },
    fileHighLight: function (fileItem, highLight) {
      fileItem.active = highLight
    },
    folderCheckboxClick: function (index) {
      for (var i = 0; i < this.folders.length; i++) {
        this.folders[i].selected = false
      }
      this.folders[index].selected = true
    },
    moveToFolder: function () {
      var folderId = ''
      for (var i = 0; i < this.folders.length; i++) {
        if (this.folders[i].selected) {
          folderId = this.folders[i].id
          break
        }
      }
      this.$emit('moveToFolder', folderId)
      this.$emit('closeFolderSelector')
    },
    cancelFolderSelector: function () {
      this.$emit('closeFolderSelector')
    },
    closeInputPop: function () {
      this.inputPop = false
    },
    showInputPop: function () {
      this.inputPop = true
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.folder-selector
  position absolute
  width 100%
  top 50px
  left 0px
  background-color #f5f5f5
  .selector-box
    position relative
    display block
    width 100%
    height 100%
    padding-top 40px
    box-sizing border-box
    .top-line
      position absolute
      width 100%
      height 40px
      top 0px
      left 0px
      padding 0px 30px
      line-height 40px
      color #000000
      text-align left
      background-color #ffffff
      z-index 10
      box-sizing border-box
      .back-btn
        display inline-block
        padding 0px 12px
        font-size 12px
      .selector-title
        display inline-block
        font-size 14px
      .icon-add
        display inline-block
        font-size 16px
        color #9b9b9b
        margin-left 37px
        cursor pointer
        &:hover
          color #3b3b3b
      .btn-black
        float right
        margin-top 6px
        font-size 14px
        min-width 64px
        height 26px
        line-height 26px
    .folder-list
      position relative
      display block
      width 100%
      height 100%
      padding 20px 30px
      overflow-y auto
      box-sizing border-box
      .folder-item
        width 180px
        height 180px
        float left
        margin 11px 15px 11px 0
        display block
        justify-content center
        align-items center
        position relative
        transition all .3s ease
        cursor pointer
        &.show-default-folder-img
          .img-wrap
            img
              &.defaul-folder-img
                display block
              &.folder-img
                display none
        &.selected
          .checkbox
            background-image url('../../assets/images/checkbox_click.png')
            display block
        &:hover
          .wrapper
            top -8px
          .img-file
            box-shadow rgba(169, 169, 169, 0.64) 0px 6px 30px 5px
          .layer
            &.layer-under
              width 154px
              height 170px
              top -2px
              box-shadow rgba(169, 169, 169, 0.64) 0px 6px 30px 5px
            &.layer-middle
              width 166px
              height 170px
              top 5px
              box-shadow rgba(169, 169, 169, 0.64) 0px 17px 50px 0px
            &.layer-upper
              width 178px
              height 170px
              top 12px
              box-shadow rgba(169, 169, 169, 0.64) 0px 17px 45px -10px
          .checkbox
            display block
        .wrapper
          position relative
          display flex
          width 100%
          height 100%
          justify-content center
          align-items center
          position relative
          transition all .3s ease
          cursor pointer
        .layer
          position absolute
          border 1px solid #e5e5e5
          border-radius 4px
          background-color #fff
          transition all .25s ease
          &.layer-under
            width 160px
            height 170px
            top 0
            transition all .25s ease-in
          &.layer-middle
            width 170px
            height 170px
            top 6px
            transition all .25s ease-in
          &.layer-upper
            width 178px
            height 170px
            top 12px
        .img-wrap
          width 120px
          height 120px
          position absolute
          top 25px
          background-color #fafafa
          border-radius 4px
          display flex
          justify-content center
          align-items center
          img
            max-width 100%
            max-height 100%
            &.defaul-folder-img
              display none
            &.folder-img
              display block
        .folder-msg
          position absolute
          left 10px
          bottom 9px
          line-height 16px
          .icon-folder
            font-size 12px
          .folder-title
            font-size 12px
            color #3d3d3d
            font-weight 500
            display inline-block
            max-width 119px
            height 12px
            line-height 12px
            white-space nowrap
            text-overflow ellipsis
            overflow hidden
            vertical-align middle
        .checkbox
          width 20px
          height 20px
          position absolute
          bottom 10px
          right 12px
          background-image url('../../assets/images/checkbox_hover.png')
          background-repeat no-repeat
          background-size 100%
          display none
</style>



// WEBPACK FOOTER //
// src/components/Et/FolderSelector.vue